import { motion, AnimatePresence } from "framer-motion";

export default function ConfirmModal({ isOpen, onClose, onConfirm, message }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="appointment-page modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="appointment-page modal confirm-modal-appointment"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
          >
            <div className="appointment-page modal-header">
              <h2>Confirm</h2>
            </div>

            <div className="appointment-page modal-body w-[365px]">
              <p>{message}</p>
            </div>

            <div className="appointment-page modal-footer">
              <button className="appointment-page cancel" onClick={onClose}>
                Cancel
              </button>
              <button className="appointment-page create" onClick={onConfirm}>
                Confirm
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
